export interface Game {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  rating: number;
  ratingCount: number;
  imageUrl: string;
  thumbUrl: string;
  description: string;
  tags: string[];
  platform: string;
  releaseDate: string;
  developer: string;
  isHot: boolean;
  rank: number;
}

export const games: Game[] = [
  {
    id: 'game-001',
    title: '原神',
    slug: 'genshin-impact',
    category: '角色扮演',
    categorySlug: 'rpg',
    rating: 9.5,
    ratingCount: 128600,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20open%20world%20fantasy%20game%20with%20anime%20characters%20in%20vibrant%20landscape%2C%20clean%20simple%20background%20with%20warm%20tones%2C%20soft%20atmospheric%20lighting%2C%20editorial%20gaming%20photography%20style%2C%20no%20text%20overlays%2C%20minimal%20design%2C%20artistic%20composition&width=800&height=500&seq=game-genshin-impact-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20game%20app%20icon%20style%2C%20colorful%20anime%20character%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20vibrant%20colors&width=100&height=100&seq=game-genshin-impact-thumb&orientation=squarish',
    description: '米哈游打造的开放世界冒险RPG，在提瓦特大陆自由探索，邂逅性格各异的伙伴，体验元素战斗的无穷乐趣。',
    tags: ['开放世界', '二次元', '多平台', '免费'],
    platform: 'PC/iOS/Android/PS5',
    releaseDate: '2020-09-28',
    developer: '米哈游',
    isHot: true,
    rank: 1,
  },
  {
    id: 'game-002',
    title: '王者荣耀',
    slug: 'honor-of-kings',
    category: 'MOBA',
    categorySlug: 'moba',
    rating: 9.2,
    ratingCount: 256300,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20MOBA%20mobile%20game%20with%20fantasy%20heroes%20in%20battle%20arena%2C%20clean%20warm%20background%2C%20vibrant%20action%20scene%2C%20soft%20atmospheric%20lighting%2C%20editorial%20gaming%20photography%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-honor-of-kings-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20game%20icon%20style%2C%20colorful%20hero%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-honor-of-kings-thumb&orientation=squarish',
    description: '腾讯天美出品的5V5公平对战手游，海量英雄任你选择，随时随地享受竞技快感，国民级MOBA手游。',
    tags: ['MOBA', '竞技', '多人', '免费'],
    platform: 'iOS/Android',
    releaseDate: '2015-11-26',
    developer: '腾讯天美',
    isHot: true,
    rank: 2,
  },
  {
    id: 'game-003',
    title: '崩坏：星穹铁道',
    slug: 'honkai-star-rail',
    category: '角色扮演',
    categorySlug: 'rpg',
    rating: 9.4,
    ratingCount: 98300,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20sci%20fi%20space%20train%20RPG%20game%20with%20anime%20characters%2C%20clean%20cosmic%20background%20with%20warm%20tones%2C%20soft%20atmospheric%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-honkai-star-rail-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Honkai%20Star%20Rail%20game%20icon%20style%2C%20colorful%20anime%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-honkai-star-rail-thumb&orientation=squarish',
    description: '米哈游银河冒险回合制RPG，乘坐星穹列车穿越星际，在壮丽的宇宙舞台上展开奇幻冒险旅程。',
    tags: ['回合制', '二次元', '科幻', '免费'],
    platform: 'PC/iOS/Android/PS5',
    releaseDate: '2023-04-26',
    developer: '米哈游',
    isHot: true,
    rank: 3,
  },
  {
    id: 'game-004',
    title: '绝区零',
    slug: 'zenless-zone-zero',
    category: '动作冒险',
    categorySlug: 'action',
    rating: 9.1,
    ratingCount: 67200,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20urban%20fantasy%20action%20game%20with%20anime%20characters%20in%20city%2C%20clean%20warm%20background%2C%20vibrant%20neon%20accents%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-zenless-zone-zero-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Zenless%20Zone%20Zero%20game%20icon%20style%2C%20colorful%20anime%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-zenless-zone-zero-thumb&orientation=squarish',
    description: '米哈游都市幻想动作RPG，在末日后的新艾利都，与伙伴们并肩作战，体验酣畅淋漓的高速战斗。',
    tags: ['动作', '都市', '二次元', '免费'],
    platform: 'PC/iOS/Android/PS5',
    releaseDate: '2024-07-04',
    developer: '米哈游',
    isHot: true,
    rank: 4,
  },
  {
    id: 'game-005',
    title: '黑神话：悟空',
    slug: 'black-myth-wukong',
    category: '动作冒险',
    categorySlug: 'action',
    rating: 9.6,
    ratingCount: 185200,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20Chinese%20mythology%20monkey%20king%20warrior%20in%20ancient%20forest%2C%20clean%20warm%20background%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-black-myth-wukong-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Black%20Myth%20Wukong%20game%20icon%20style%2C%20monkey%20king%20warrior%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-black-myth-wukong-thumb&orientation=squarish',
    description: '游戏科学打造的中国神话动作RPG，化身天命人踏上西游旅程，以棍法和法术挑战各路妖魔，国产3A里程碑之作。',
    tags: ['动作', '神话', '3A', '单机'],
    platform: 'PC/PS5/Xbox',
    releaseDate: '2024-08-20',
    developer: '游戏科学',
    isHot: true,
    rank: 5,
  },
  {
    id: 'game-006',
    title: '和平精英',
    slug: 'game-for-peace',
    category: '射击',
    categorySlug: 'shooter',
    rating: 8.9,
    ratingCount: 312400,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20battle%20royale%20shooter%20game%20with%20soldiers%20in%20combat%2C%20clean%20warm%20background%2C%20action%20scene%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-game-for-peace-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Game%20for%20Peace%20game%20icon%20style%2C%20soldier%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-game-for-peace-thumb&orientation=squarish',
    description: '腾讯光子出品的战术竞技手游，百人空降、自由作战，真实战场体验，国内最受欢迎的吃鸡手游。',
    tags: ['射击', '战术竞技', '多人', '免费'],
    platform: 'iOS/Android',
    releaseDate: '2019-05-08',
    developer: '腾讯光子',
    isHot: true,
    rank: 6,
  },
  {
    id: 'game-007',
    title: '蛋仔派对',
    slug: 'eggy-party',
    category: '休闲',
    categorySlug: 'casual',
    rating: 8.7,
    ratingCount: 198500,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20cute%20egg%20characters%20party%20game%20with%20playful%20obstacles%2C%20clean%20warm%20background%2C%20fun%20atmosphere%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-eggy-party-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Eggy%20Party%20game%20icon%20style%2C%20cute%20egg%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-eggy-party-thumb&orientation=squarish',
    description: '网易出品的欢乐派对竞技手游，操控可爱的蛋仔在各种趣味关卡中闯关，和好友一起畅享欢乐时光。',
    tags: ['休闲', '派对', '多人', '免费'],
    platform: 'iOS/Android',
    releaseDate: '2022-05-27',
    developer: '网易',
    isHot: true,
    rank: 7,
  },
  {
    id: 'game-008',
    title: '暗区突围',
    slug: 'arena-breakout',
    category: '射击',
    categorySlug: 'shooter',
    rating: 8.8,
    ratingCount: 87300,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20tactical%20military%20shooter%20game%20with%20soldiers%20in%20dark%20zone%2C%20clean%20warm%20background%2C%20tense%20atmosphere%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-arena-breakout-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Arena%20Breakout%20game%20icon%20style%2C%20tactical%20soldier%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-arena-breakout-thumb&orientation=squarish',
    description: '腾讯魔方出品的硬核战术射击手游，高自由度枪械改装系统，真实战场沉浸感，生存撤离玩法带来极致紧张体验。',
    tags: ['射击', '战术', '硬核', '免费'],
    platform: 'iOS/Android/PC',
    releaseDate: '2023-07-13',
    developer: '腾讯魔方',
    isHot: false,
    rank: 8,
  },
  {
    id: 'game-009',
    title: '逆水寒手游',
    slug: 'justice-online-mobile',
    category: '角色扮演',
    categorySlug: 'rpg',
    rating: 9.0,
    ratingCount: 112400,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20ancient%20Chinese%20martial%20arts%20MMORPG%20with%20warriors%20in%20beautiful%20landscape%2C%20clean%20warm%20background%2C%20elegant%20atmosphere%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-justice-online-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Justice%20Online%20Mobile%20game%20icon%20style%2C%20ancient%20Chinese%20warrior%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-justice-online-thumb&orientation=squarish',
    description: '网易武侠开放世界MMORPG手游，绝美大宋江湖画面，自由探索武侠世界，体验快意恩仇的江湖人生。',
    tags: ['武侠', 'MMORPG', '开放世界', '免费'],
    platform: 'iOS/Android/PC',
    releaseDate: '2023-06-30',
    developer: '网易',
    isHot: false,
    rank: 9,
  },
  {
    id: 'game-010',
    title: '永劫无间手游',
    slug: 'naraka-bladepoint-mobile',
    category: '动作冒险',
    categorySlug: 'action',
    rating: 8.9,
    ratingCount: 75800,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20martial%20arts%20battle%20royale%20game%20with%20warriors%20fighting%2C%20clean%20warm%20background%2C%20dynamic%20action%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-naraka-bladepoint-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Naraka%20Bladepoint%20game%20icon%20style%2C%20martial%20arts%20warrior%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-naraka-bladepoint-thumb&orientation=squarish',
    description: '网易24工作室出品的武侠竞技动作手游，近战冷兵器格斗为核心，飞索自由移动，体验刀光剑影的东方美学竞技。',
    tags: ['动作', '武侠', '竞技', '免费'],
    platform: 'iOS/Android/PC',
    releaseDate: '2024-07-25',
    developer: '网易24工作室',
    isHot: false,
    rank: 10,
  },
  {
    id: 'game-011',
    title: '光·遇',
    slug: 'sky-children-of-light',
    category: '休闲',
    categorySlug: 'casual',
    rating: 9.3,
    ratingCount: 156200,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20dreamy%20social%20adventure%20game%20with%20flying%20characters%20in%20cloud%20kingdom%2C%20clean%20warm%20background%2C%20peaceful%20atmosphere%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-sky-children-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Sky%20Children%20of%20Light%20game%20icon%20style%2C%20dreamy%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-sky-children-thumb&orientation=squarish',
    description: '陈星汉团队打造的社交冒险游戏，在唯美的云端王国中自由飞翔，与来自世界各地的玩家相遇、同行，感受温暖与感动。',
    tags: ['社交', '冒险', '治愈', '免费'],
    platform: 'iOS/Android/Switch/PS5',
    releaseDate: '2019-07-18',
    developer: 'thatgamecompany',
    isHot: false,
    rank: 11,
  },
  {
    id: 'game-012',
    title: '鸣潮',
    slug: 'wuthering-waves',
    category: '角色扮演',
    categorySlug: 'rpg',
    rating: 8.6,
    ratingCount: 64200,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20stylized%20post%20apocalyptic%20open%20world%20action%20RPG%20with%20anime%20characters%2C%20clean%20warm%20background%2C%20dramatic%20atmosphere%2C%20soft%20lighting%2C%20editorial%20gaming%20style%2C%20no%20text%2C%20minimal%20design&width=800&height=500&seq=game-wuthering-waves-card&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Wuthering%20Waves%20game%20icon%20style%2C%20anime%20character%2C%20clean%20simple%20background%2C%20minimal%20design&width=100&height=100&seq=game-wuthering-waves-thumb&orientation=squarish',
    description: '库洛游戏出品的开放世界动作RPG，在灾后废土世界中探索，高速战斗与华丽技能组合，带来极致的战斗爽感。',
    tags: ['开放世界', '动作', '二次元', '免费'],
    platform: 'PC/iOS/Android',
    releaseDate: '2024-05-23',
    developer: '库洛游戏',
    isHot: false,
    rank: 12,
  },
];

export const getHotGames = (): Game[] => games.filter((g) => g.isHot);

export const getGamesByCategory = (categorySlug: string): Game[] =>
  games.filter((g) => g.categorySlug === categorySlug);

export const getGameById = (id: string): Game | undefined =>
  games.find((g) => g.id === id);

export const getGameBySlug = (slug: string): Game | undefined =>
  games.find((g) => g.slug === slug);

export const getRankedGames = (limit: number = 10): Game[] =>
  [...games].sort((a, b) => a.rank - b.rank).slice(0, limit);